import React, { useEffect, useRef, useState } from 'react';
import { LuCheckCheck, LuChevronDown, LuCheckCircle2, LuMapPin, LuMic, LuPaperclip, LuPhone, LuRotateCcw, LuSend, LuSparkles, LuSquare, LuWrench, LuXCircle } from 'react-icons/lu';

const SAMPLE_LOCATION = { latitude: 4.6097, longitude: -74.0817, address: '' };
const MAX_AUDIO_BYTES = 3 * 1024 * 1024;

export const WA_CSS = `
.su-wa { --wa-chat: #e5ddd5; --wa-dot: #d8cfc6; --wa-me: #dcf8c6; --wa-them: #ffffff; --wa-ink: #2D2D2D; --wa-meta: #667781; --wa-link: #2a9fd0; --wa-read: #53bdeb; --wa-sys: #ffffff; --wa-sys-ink: #555555; --wa-notice: #fff8d6; --wa-notice-ink: #6b5a12; --wa-bar: var(--su-surface);
    display: flex; flex-direction: column; width: 100%; height: 100%; overflow: hidden; }
#body-dark.dark .su-wa { --wa-chat: #0b141a; --wa-dot: #16232b; --wa-me: #005c4b; --wa-them: #202c33; --wa-ink: #e9edef; --wa-meta: #9fb4b9; --wa-link: #53bdeb; --wa-sys: #182229; --wa-sys-ink: #aebac1; --wa-notice: #2b2a1c; --wa-notice-ink: #e6d9a0; }
.su-wa-h { display: flex; align-items: center; gap: 12px; min-height: 64px; padding: 8px 14px; border-bottom: 1px solid var(--su-line); background: var(--wa-bar); flex-shrink: 0; }
.su-wa-av { width: 42px; height: 42px; flex-shrink: 0; display: grid; place-items: center; border-radius: 50%; background: #7563D8; color: #ffffff; }
.su-wa-id { flex: 1; min-width: 0; display: flex; flex-direction: column; }
.su-wa-id b { font-size: 16px; font-weight: 600; color: var(--su-ink); white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.su-wa-id span { font-size: 12.5px; color: var(--su-ink-3); }
.su-wa-id span.typing { color: var(--su-wa-ink); font-weight: 600; }
.su-wa-ib { width: 38px; height: 38px; flex-shrink: 0; display: grid; place-items: center; border: none; border-radius: 50%; background: none; color: var(--su-ink-2); cursor: pointer; }
.su-wa-ib:hover:not(:disabled) { background: var(--su-raised); }
.su-wa-ib:disabled { opacity: 0.5; cursor: default; }
.su-wa-msgs { flex: 1; min-height: 0; overflow-y: auto; display: flex; flex-direction: column; gap: 6px; padding: 14px 6%; background-color: var(--wa-chat); background-image: radial-gradient(var(--wa-dot) 1px, transparent 1px); background-size: 20px 20px; }
.su-wa-sys { align-self: center; display: inline-flex; align-items: center; gap: 6px; max-width: 92%; margin: 4px 0; padding: 5px 10px; border-radius: 8px; background: var(--wa-sys); color: var(--wa-sys-ink); font-size: 12px; line-height: 1.35; box-shadow: 0 1px 1px rgba(0, 0, 0, 0.1); }
.su-wa-sys span { white-space: nowrap; overflow: hidden; text-overflow: ellipsis; }
.su-wa-sys.bad { color: var(--su-red-ink); }
.su-wa-notice { align-self: center; max-width: 92%; margin-bottom: 6px; padding: 6px 12px; border-radius: 8px; background: var(--wa-notice); color: var(--wa-notice-ink); font-size: 12px; line-height: 1.4; text-align: center; box-shadow: 0 1px 1px rgba(0, 0, 0, 0.08); }
.su-wa-heard { align-self: flex-end; max-width: 78%; font-size: 12px; font-style: italic; color: var(--wa-sys-ink); }
.su-wa-row { display: flex; flex-direction: column; align-items: flex-start; gap: 3px; max-width: 80%; }
.su-wa-row.me { align-self: flex-end; align-items: flex-end; }
.su-wa-b { min-width: 86px; max-width: 100%; padding: 6px 9px 4px; border-radius: 8px; background: var(--wa-them); color: var(--wa-ink); font-size: 14.5px; line-height: 1.42; white-space: pre-wrap; overflow-wrap: anywhere; box-shadow: 0 1px 1px rgba(0, 0, 0, 0.13); }
.su-wa-row.me .su-wa-b { background: var(--wa-me); }
.su-wa-meta { display: flex; align-items: center; justify-content: flex-end; gap: 4px; margin-top: 1px; font-size: 11px; color: var(--wa-meta); }
.su-wa-meta .read { color: var(--wa-read); }
.su-wa-opt { display: flex; align-items: center; justify-content: center; gap: 6px; width: 100%; padding: 8px 12px; border: none; border-radius: 8px; background: var(--wa-them); color: var(--wa-link); font-size: 14px; font-weight: 600; cursor: pointer; box-shadow: 0 1px 1px rgba(0, 0, 0, 0.13); }
.su-wa-opt:disabled { opacity: 0.6; cursor: default; }
.su-wa-typing { display: inline-flex; gap: 4px; padding: 11px 13px; border-radius: 8px; background: var(--wa-them); box-shadow: 0 1px 1px rgba(0, 0, 0, 0.13); align-self: flex-start; }
.su-wa-typing i { width: 7px; height: 7px; border-radius: 50%; background: var(--wa-meta); animation: su-wa-dot 1.2s infinite; }
.su-wa-typing i:nth-child(2) { animation-delay: 0.2s; }
.su-wa-typing i:nth-child(3) { animation-delay: 0.4s; }
@keyframes su-wa-dot { 0%, 60%, 100% { opacity: 0.35; transform: none; } 30% { opacity: 1; transform: translateY(-3px); } }
@media (prefers-reduced-motion: reduce) { .su-wa-typing i { animation: none; } }
.su-wa-ctx { flex-shrink: 0; border-top: 1px solid var(--su-line); background: var(--wa-bar); }
.su-wa-ctx > button { display: flex; align-items: center; justify-content: space-between; width: 100%; padding: 8px 14px; border: none; background: none; color: var(--su-ink-3); font-size: 12px; font-weight: 600; cursor: pointer; }
.su-wa-ctx .open { transform: rotate(180deg); }
.su-wa-ctx > div { display: flex; flex-wrap: wrap; gap: 4px; max-height: 110px; overflow-y: auto; padding: 0 14px 10px; }
.su-wa-ctx > div span { padding: 3px 8px; border-radius: 6px; background: var(--su-raised); color: var(--su-ink-2); font-size: 12px; }
.su-wa-sheet { display: flex; flex-direction: column; gap: 8px; padding: 10px 14px; border-top: 1px solid var(--su-line); background: var(--wa-bar); flex-shrink: 0; }
.su-wa-sheet b { display: inline-flex; align-items: center; gap: 6px; font-size: 13px; font-weight: 600; color: var(--su-ink); }
.su-wa-sheet-row { display: flex; gap: 8px; }
.su-kit .su-wa-sheet input { flex: 1; min-width: 0; padding: 7px 2px; border: none !important; border-bottom: 1px solid var(--su-line) !important; border-radius: 0; outline: none; box-shadow: none !important; background: transparent !important; color: var(--su-ink) !important; font-family: inherit; font-size: 14px; }
.su-kit .su-wa-sheet input:focus { border-bottom-color: var(--su-sky) !important; }
.su-kit .su-wa-sheet input::placeholder { color: var(--su-ink-3); font-style: normal; }
.su-wa-sheet-acts { display: flex; justify-content: flex-end; gap: 8px; }
.su-wa-c { display: flex; align-items: center; gap: 8px; padding: 10px 14px 12px; background-color: var(--wa-chat); flex-shrink: 0; }
.su-wa-pill { flex: 1; min-width: 0; display: flex; align-items: center; gap: 2px; padding: 3px 6px 3px 16px; border-radius: 24px; background: var(--wa-them); box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1); }
.su-kit .su-wa-pill input { flex: 1; min-width: 0; height: 38px; padding: 0; border: none !important; outline: none; box-shadow: none !important; background: transparent !important; color: var(--wa-ink) !important; font-family: inherit; font-size: 15px; }
.su-kit .su-wa-pill input::placeholder { color: var(--wa-meta); font-style: normal; }
.su-wa-round { width: 44px; height: 44px; flex-shrink: 0; display: grid; place-items: center; border: none; border-radius: 50%; background: #2fae4e; color: #ffffff; cursor: pointer; box-shadow: 0 1px 2px rgba(0, 0, 0, 0.15); }
.su-wa-round:disabled { opacity: 0.6; cursor: default; }
.su-wa-round.rec { background: #FF2242; }
`;

export const nowTime = () => new Date().toLocaleTimeString('es-CO', { hour: 'numeric', minute: '2-digit' });

export const formatWhatsApp = (text) =>
  String(text ?? '')
    .split(/(\*[^*\n]+\*|_[^_\n]+_)/g)
    .map((part, index) => {
      if (/^\*[^*\n]+\*$/.test(part)) return <strong key={index}>{part.slice(1, -1)}</strong>;
      if (/^_[^_\n]+_$/.test(part)) return <em key={index}>{part.slice(1, -1)}</em>;
      return part;
    });

const bubbleFromTranscript = (item) => {
  if (item.typeMessage === 'text') return { from: 'bot', text: item.content };
  if (item.typeMessage === 'interactive_location') return { from: 'bot', text: item.content?.message, action: { kind: 'location', label: 'Enviar ubicación' } };
  if (item.typeMessage === 'interactive_contact') return { from: 'bot', text: item.content?.message, action: { kind: 'contact', label: 'Compartir contacto' } };
  if (item.typeMessage === 'interactive') return { from: 'bot', text: item.content?.message, options: (item.content?.options || []).map((option) => option.label) };
  if (item.typeMessage === 'template') {
    const params = (item.content?.parametersBody || []).filter(Boolean);
    return { from: 'bot', text: `📄 Plantilla «${item.content?.name || item.content?.id}»${params.length ? `\nParámetros: ${params.join(' · ')}` : ''}` };
  }
  if (item.typeMessage === 'media') return { from: 'bot', text: `📎 ${item.content?.name || 'Archivo'}${item.content?.fileText ? `\n${item.content.fileText}` : ''}` };
  return { from: 'bot', text: JSON.stringify(item.content) };
};

const AgentTester = ({ botId, api, config, onUsedTools, onTurn, headerExtra }) => {
  const [items, setItems] = useState([]);
  const [state, setState] = useState({});
  const [context, setContext] = useState([]);
  const [contextOpen, setContextOpen] = useState(false);
  const [text, setText] = useState('');
  const [loading, setLoading] = useState(false);
  const [locationForm, setLocationForm] = useState(null);
  const [contactForm, setContactForm] = useState(null);
  const [recording, setRecording] = useState(false);
  const scrollRef = useRef(null);
  const recorderRef = useRef(null);
  const audioInputRef = useRef(null);
  const name = config?.companyName ? `Asistente de ${config.companyName}` : 'Asistente';

  useEffect(() => {
    if (scrollRef.current) scrollRef.current.scrollTop = scrollRef.current.scrollHeight;
  }, [items, loading]);

  const reset = () => {
    setItems([]);
    setState({});
    setContext([]);
    setLocationForm(null);
    setContactForm(null);
    onUsedTools?.([]);
  };

  const send = async (message, label) => {
    if (loading) return;
    setItems((prev) => [...prev, { from: 'user', text: label, time: nowTime() }]);
    setLoading(true);
    try {
      const result = await api.test(botId, { message, state, agentConfig: config });
      setState(result.state || {});
      setContext(result.context || []);
      const time = nowTime();
      const traces = (result.traces || []).map((trace) => ({ from: 'trace', trace }));
      const heard = result.transcription ? [{ from: 'note', text: `Entendió: «${result.transcription}»` }] : [];
      setItems((prev) => [...prev, ...heard, ...traces, ...(result.messages || []).map((item) => ({ ...bubbleFromTranscript(item), time }))]);
      const used = (result.traces || []).filter((trace) => trace.output?.ok).map((trace) => trace.name);
      if (used.length) onUsedTools?.((prev) => Array.from(new Set([...(prev || []), ...used])));
      onTurn?.(used);
    } catch (error) {
      const details = error.validation?.errors?.length ? `: ${error.validation.errors.join(' · ')}` : '';
      setItems((prev) => [...prev, { from: 'error', text: `${error.message}${details}` }]);
    } finally {
      setLoading(false);
    }
  };

  const sendText = () => {
    const value = text.trim();
    if (!value) return;
    setText('');
    send({ type: 'text', text: value }, value);
  };

  const sendAudioBlob = (blob) => {
    if (!blob?.size) return;
    if (blob.size > MAX_AUDIO_BYTES) {
      setItems((prev) => [...prev, { from: 'error', text: 'El audio supera los 3 MB.' }]);
      return;
    }
    const reader = new FileReader();
    reader.onload = () => {
      const data = String(reader.result || '').split(',')[1] || '';
      send({ type: 'audio', data, mime: (blob.type || 'audio/webm').split(';')[0] }, '🎤 Nota de voz');
    };
    reader.readAsDataURL(blob);
  };

  const toggleRecording = async () => {
    if (recording) {
      recorderRef.current?.stop();
      return;
    }
    try {
      const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
      const recorder = new MediaRecorder(stream);
      const chunks = [];
      recorder.ondataavailable = (event) => event.data.size && chunks.push(event.data);
      recorder.onstop = () => {
        stream.getTracks().forEach((track) => track.stop());
        setRecording(false);
        sendAudioBlob(new Blob(chunks, { type: recorder.mimeType || 'audio/webm' }));
      };
      recorderRef.current = recorder;
      recorder.start();
      setRecording(true);
    } catch (error) {
      setItems((prev) => [...prev, { from: 'error', text: 'No se pudo usar el micrófono. Sube un archivo de audio.' }]);
    }
  };

  const handleAction = (action) => {
    if (action.kind === 'location') {
      setContactForm(null);
      setLocationForm({ ...SAMPLE_LOCATION });
    }
    if (action.kind === 'contact') {
      setLocationForm(null);
      setContactForm({ phone: '573001234567' });
    }
  };

  const sendLocation = () => {
    const { latitude, longitude, address } = locationForm;
    setLocationForm(null);
    send({ type: 'location', latitude: Number(latitude), longitude: Number(longitude), address: address || undefined }, '📍 Ubicación compartida');
  };

  const sendContact = () => {
    const phone = contactForm.phone.trim();
    if (!phone) return;
    setContactForm(null);
    send({ type: 'contact', phone }, '📇 Contacto compartido');
  };

  const renderItem = (item, index) => {
    if (item.from === 'trace') {
      const { trace } = item;
      const ok = trace.output?.ok;
      const detail = trace.output?.error || (trace.output?.simulado ? 'simulado' : '');
      return (
        <div key={index} className={`su-wa-sys${ok ? '' : ' bad'}`} title={JSON.stringify({ datos: trace.args, resultado: trace.output }, null, 2)}>
          <LuWrench className="su-ic" size={13} />
          <span>
            {trace.name}
            {detail ? ` · ${detail}` : ''}
          </span>
          {ok ? <LuCheckCircle2 className="su-ic" size={13} color="#2fae4e" /> : <LuXCircle className="su-ic" size={13} />}
        </div>
      );
    }
    if (item.from === 'note') return <div key={index} className="su-wa-heard">{item.text}</div>;
    if (item.from === 'error') return <div key={index} className="su-wa-sys bad" style={{ whiteSpace: 'normal' }}>{item.text}</div>;

    const mine = item.from === 'user';
    return (
      <div key={index} className={`su-wa-row${mine ? ' me' : ''}`}>
        <div className="su-wa-b">
          {formatWhatsApp(item.text)}
          <div className="su-wa-meta">
            <span>{item.time}</span>
            {mine && <LuCheckCheck className="su-ic read" size={15} />}
          </div>
        </div>
        {item.action && (
          <button type="button" className="su-wa-opt" onClick={() => handleAction(item.action)}>
            {item.action.kind === 'location' ? <LuMapPin className="su-ic" size={15} /> : <LuPhone className="su-ic" size={15} />}
            {item.action.label}
          </button>
        )}
        {(item.options || []).map((option) => (
          <button key={option} type="button" className="su-wa-opt" disabled={loading} onClick={() => send({ type: 'button', title: option }, option)}>
            {option}
          </button>
        ))}
      </div>
    );
  };

  const hasText = Boolean(text.trim());

  return (
    <div className="su-wa">
      <style>{WA_CSS}</style>
      <div className="su-wa-h">
        <span className="su-wa-av">
          <LuSparkles className="su-ic" size={20} />
        </span>
        <div className="su-wa-id">
          <b title={name}>{name}</b>
          <span className={loading ? 'typing' : ''}>{loading ? 'escribiendo…' : 'Conversación de prueba'}</span>
        </div>
        <button type="button" className="su-wa-ib" title="Reiniciar conversación" aria-label="Reiniciar conversación" onClick={reset}>
          <LuRotateCcw className="su-ic" size={17} />
        </button>
        {headerExtra}
      </div>

      <div ref={scrollRef} className="su-wa-msgs su-soft-scroll">
        <div className="su-wa-notice">Prueba con el borrador actual, aunque no esté guardado. Las consultas GET van de verdad; el resto se simula.</div>
        {!items.length && <div className="su-wa-sys">Escribe como lo haría un cliente.</div>}
        {items.map(renderItem)}
        {loading && (
          <div className="su-wa-typing" aria-label="El agente está escribiendo">
            <i />
            <i />
            <i />
          </div>
        )}
      </div>

      {context.length > 0 && (
        <div className="su-wa-ctx">
          <button type="button" aria-expanded={contextOpen} onClick={() => setContextOpen((value) => !value)}>
            Lo que ve la IA ahora · {context.length}
            <LuChevronDown className={`su-ic${contextOpen ? ' open' : ''}`} size={15} />
          </button>
          {contextOpen && (
            <div>
              {context.map((line) => (
                <span key={line}>{line}</span>
              ))}
            </div>
          )}
        </div>
      )}

      {locationForm && (
        <div className="su-wa-sheet">
          <b>
            <LuMapPin className="su-ic" size={15} />
            Ubicación de prueba
          </b>
          <div className="su-wa-sheet-row">
            <input id="tester-latitude" aria-label="Latitud" value={locationForm.latitude} onChange={(event) => setLocationForm({ ...locationForm, latitude: event.target.value })} placeholder="Latitud" />
            <input id="tester-longitude" aria-label="Longitud" value={locationForm.longitude} onChange={(event) => setLocationForm({ ...locationForm, longitude: event.target.value })} placeholder="Longitud" />
          </div>
          <div className="su-wa-sheet-row">
            <input id="tester-address" aria-label="Dirección" value={locationForm.address} onChange={(event) => setLocationForm({ ...locationForm, address: event.target.value })} placeholder="Dirección (vacío = la busca el nodo de geocodificación)" />
          </div>
          <div className="su-wa-sheet-acts">
            <button type="button" className="su-btn ghost" onClick={() => setLocationForm(null)}>
              Cancelar
            </button>
            <button type="button" className="su-btn" onClick={sendLocation}>
              Enviar ubicación
            </button>
          </div>
        </div>
      )}

      {contactForm && (
        <div className="su-wa-sheet">
          <b>
            <LuPhone className="su-ic" size={15} />
            Contacto de prueba
          </b>
          <div className="su-wa-sheet-row">
            <input id="tester-contact" aria-label="Teléfono con código de país" value={contactForm.phone} onChange={(event) => setContactForm({ phone: event.target.value })} placeholder="Teléfono con código de país" />
          </div>
          <div className="su-wa-sheet-acts">
            <button type="button" className="su-btn ghost" onClick={() => setContactForm(null)}>
              Cancelar
            </button>
            <button type="button" className="su-btn" onClick={sendContact}>
              Enviar contacto
            </button>
          </div>
        </div>
      )}

      <div className="su-wa-c">
        <div className="su-wa-pill">
          <input
            id="tester-message"
            aria-label="Mensaje de prueba"
            value={text}
            disabled={loading}
            onChange={(event) => setText(event.target.value)}
            onKeyDown={(event) => event.key === 'Enter' && sendText()}
            placeholder={recording ? 'Grabando… toca el botón para enviar' : 'Escribe un mensaje'}
          />
          <input
            ref={audioInputRef}
            type="file"
            accept="audio/*"
            style={{ display: 'none' }}
            onChange={(event) => {
              const file = event.target.files?.[0];
              event.target.value = '';
              if (file) sendAudioBlob(file);
            }}
          />
          <button type="button" className="su-wa-ib" title="Subir un audio" aria-label="Subir un audio" onClick={() => audioInputRef.current?.click()} disabled={loading || recording}>
            <LuPaperclip className="su-ic" size={18} />
          </button>
        </div>
        {hasText && !recording ? (
          <button type="button" className="su-wa-round" title="Enviar" aria-label="Enviar" onClick={sendText} disabled={loading}>
            <LuSend className="su-ic" size={18} />
          </button>
        ) : (
          <button
            type="button"
            className={`su-wa-round${recording ? ' rec' : ''}`}
            title={recording ? 'Detener y enviar' : 'Grabar nota de voz'}
            aria-label={recording ? 'Detener y enviar' : 'Grabar nota de voz'}
            aria-pressed={recording}
            onClick={toggleRecording}
            disabled={loading}
          >
            {recording ? <LuSquare className="su-ic" size={15} /> : <LuMic className="su-ic" size={19} />}
          </button>
        )}
      </div>
    </div>
  );
};

export default AgentTester;
